






















import {Component, Vue} from 'vue-property-decorator';
import store from '@/store';
import cart from '@/store/modules/cart';
import {getFullUrl} from '@/commons/redirectManager';
import app from '@/store/modules/app';
import device from '@/store/modules/device';


@Component({})
export default class StripHeader extends Vue {
    get stripHeader() {
        return store.state.options.stripHeader;
    }

    get staticStripHeader() {
        return this.stripHeader.static;
    }

    get dynamicStripHeader() {
        return this.stripHeader.dynamic;
    }

    get orderNumber() {
        return this.dynamicStripHeader.orderNumber;
    }

    get trackingUrl() {
        return this.dynamicStripHeader.trackingUrl;
    }

    get orderUrl() {
        return this.trackingUrl
            ? this.trackingUrl
            : getFullUrl(`sales/order/view/order_id/${this.dynamicStripHeader.orderId}`);
    }

    get stripHeaderStyle() {
        return {
            '--strip-header-background-color': this.staticStripHeader.backgroundColorWeb,
            '--strip-header-background-color-md': this.staticStripHeader.backgroundColorMobile,
            '--strip-header-color': this.staticStripHeader.foregroundColorWeb,
            '--strip-header-color-md': this.staticStripHeader.foregroundColorMobile,
        };
    }

    get isMobile() {
        if (!app.isApp && device.isMobile) {
            return true;
        }
    }

    public getCartRuleText(): string {
        const cartRules = Object.entries(this.stripHeader.checkout.cartRules);
        const cartRule = cart.cart.extension_attributes.cart_rules;

        if (cartRule && cartRules) {
            const found: any = cartRules.find((rule: any) => rule[1].cart_rule_id === cartRule);
            if (typeof found === 'object') {
                return found[1].strip_text;
            }
        }
        return '';
    }


}
